var _filter, _filter2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 92,
    viewBox: "0 0 106 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2124 47.1378C13.5681 42.0276 14.246 39.4725 15.6986 37.5726C16.9805 35.8961 18.6819 34.5873 20.6311 33.7782C22.8399 32.8613 25.4834 32.8613 30.7704 32.8613H75.9347C81.3193 32.8613 84.0116 32.8613 86.2482 33.8048C88.2215 34.6372 89.936 35.9825 91.2139 37.7012C92.6623 39.6491 93.3027 42.2642 94.5836 47.4942L97.1795 58.0942C99.1646 66.2003 100.157 70.2533 99.1595 73.4433C98.285 76.2394 96.4179 78.619 93.9101 80.1335C91.049 81.8613 86.8762 81.8613 78.5306 81.8613H27.9581C19.4655 81.8613 15.2193 81.8613 12.3364 80.0976C9.81031 78.5522 7.94485 76.1273 7.09888 73.2894C6.13344 70.0507 7.22234 65.9464 9.40012 57.7378L12.2124 47.1378Z",
    fill: "url(#paint0_linear_86_2393)",
    style: {},
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6957 47.266C14.0631 42.1116 14.7185 39.6777 16.0958 37.8763C17.3243 36.2696 18.9548 35.0153 20.8227 34.24C22.9171 33.3706 25.4377 33.3613 30.7704 33.3613H75.9347C81.366 33.3613 83.9333 33.3709 86.0539 34.2655C87.9449 35.0632 89.588 36.3525 90.8127 37.9995C92.186 39.8465 92.806 42.3378 94.0979 47.6132L96.6938 58.2132C97.6886 62.2751 98.4264 65.2897 98.7938 67.688C99.1607 70.0826 99.148 71.8052 98.6823 73.2941C97.8443 75.9736 96.0549 78.2541 93.6516 79.7055C92.3162 80.5119 90.6461 80.934 88.233 81.1473C85.8161 81.3609 82.7125 81.3613 78.5306 81.3613H27.9581C23.7026 81.3613 20.544 81.3609 18.0878 81.1428C15.6351 80.9251 13.9425 80.4941 12.5973 79.6711C10.1765 78.1901 8.38877 75.8662 7.57805 73.1465C7.12755 71.6353 7.14501 69.8888 7.56352 67.4623C7.98263 65.0323 8.79215 61.9792 9.88341 57.866L12.6957 47.266Z",
    stroke: "url(#paint1_linear_86_2393)",
    style: {},
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_86_2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 8.86133C56 7.20447 54.6569 5.86133 53 5.86133C51.3431 5.86133 50 7.20447 50 8.86133L56 8.86133ZM50.8787 60.9826C52.0503 62.1542 53.9498 62.1542 55.1213 60.9826L74.2132 41.8908C75.3848 40.7192 75.3848 38.8197 74.2132 37.6481C73.0416 36.4766 71.1421 36.4766 69.9706 37.6481L53 54.6187L36.0294 37.6481C34.8579 36.4766 32.9584 36.4766 31.7868 37.6481C30.6152 38.8197 30.6152 40.7192 31.7868 41.8908L50.8787 60.9826ZM50 8.86133L50 58.8613L56 58.8613L56 8.86133L50 8.86133Z",
    fill: "white",
    style: (_ref2 = {
      fill: "white"
    }, _defineProperty(_ref2, "fill", "white"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_2393",
    x: 0.744904,
    y: 30.8613,
    width: 104.807,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_2393",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_86_2393",
    x: 28.9081,
    y: 5.86133,
    width: 48.1838,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_86_2393"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_2393",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_2393",
    x1: 53,
    y1: 32.8613,
    x2: 53,
    y2: 81.8613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: (_ref3 = {
      stopColor: "none"
    }, _defineProperty(_ref3, "stopColor", "none"), _defineProperty(_ref3, "stopOpacity", 0), _ref3)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9,
    style: (_ref4 = {
      stopColor: "white"
    }, _defineProperty(_ref4, "stopColor", "white"), _defineProperty(_ref4, "stopOpacity", 0.9), _ref4)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_86_2393",
    x1: 53,
    y1: 32.8613,
    x2: 53,
    y2: 81.8613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118344,
    stopColor: "white",
    stopOpacity: 0,
    style: (_ref5 = {
      stopColor: "none"
    }, _defineProperty(_ref5, "stopColor", "none"), _defineProperty(_ref5, "stopOpacity", 0), _ref5)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: (_ref6 = {
      stopColor: "white"
    }, _defineProperty(_ref6, "stopColor", "white"), _defineProperty(_ref6, "stopOpacity", 1), _ref6)
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.38876b2905b29e4947100852832af02f.svg";
export { ForwardRef as ReactComponent };